import { FC, ReactNode, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { Footer } from './footer'
import { Header } from './header'
import { ScrollToTop } from './styled'

export type LayoutProps = {
  children?: ReactNode
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const [scrollButton, setScrollButton] = useState(false)
  const onScroll = () => {
    if (window.scrollY >= window.innerHeight * 1.5) {
      setScrollButton(true)
    } else {
      setScrollButton(false)
    }
  }
  useEffect(() => {
    window.removeEventListener('scroll', onScroll)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return (
    <>
      <Header onTop={false} isTransparent={false} inverted={false} />
      <Outlet />
      {children}
      <Footer />
      <ScrollToTop
        style={{
          opacity: scrollButton ? 1 : 0,
        }}
        onClick={() => window?.scrollTo(0, 0)}
      />
    </>
  )
}
